export default __webpack_public_path__ + "static/media/template-icon.e4cede99.svg";